import React from 'react';
import PropTypes from 'prop-types';
import Radio from '../../../customF7/radio/radio';
import { getIcon } from '../../../helpers/utils';

export default function AtrustOption(props) {
  const { title, desc, icon, selected, onClick, id } = props;

  return (
    <div
      id={id}
      className={'dialogOption ' + (selected ? 'selected' : '')}
      onClick={onClick}
    >
      <Radio checked={selected}></Radio>
      <div>
        <label>
          {getIcon(icon)} {title}
        </label>
        <label>{desc}</label>
      </div>
    </div>
  );
}

AtrustOption.propTypes = {
  selected: PropTypes.bool,
  title: PropTypes.string,
  desc: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  id: PropTypes.string
};
